import { EllipsisOutlined } from '@ant-design/icons';
import styled from 'styled-components';

export const EllipsisIcon = styled(EllipsisOutlined)<{ $size?: number }>`
  font-size: ${({ $size = 24 }) => `${$size}px`};
`;
